module.exports = __webpack_public_path__ + "img/bannerfoot.3292e10b.png";